import { render, staticRenderFns } from "./ThumbEmoteGraphic.vue?vue&type=template&id=5e4d3e8c&functional=true&"
import script from "./ThumbEmoteGraphic.vue?vue&type=script&lang=js&"
export * from "./ThumbEmoteGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports